"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Skip_exports = {};
__export(Skip_exports, {
  default: () => Skip_default
});
module.exports = __toCommonJS(Skip_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.8285 12.5019C21.9979 12.391 22.1 12.2022 22.1 11.9998C22.1 11.7974 21.9979 11.6086 21.8285 11.4977L10.5785 4.1365C10.3941 4.01585 10.1584 4.00598 9.96461 4.11079C9.77078 4.2156 9.64999 4.41822 9.64999 4.63857L9.64999 8.43667L3.07852 4.13675C2.89413 4.0161 2.65844 4.00623 2.46461 4.11104C2.27078 4.21584 2.14999 4.41847 2.14999 4.63882V19.3613C2.14999 19.5816 2.27078 19.7842 2.46461 19.889C2.65844 19.9938 2.89413 19.984 3.07851 19.8633L9.64999 15.5634V19.361C9.64999 19.5814 9.77078 19.784 9.96461 19.8888C10.1584 19.9936 10.3941 19.9837 10.5785 19.8631L21.8285 12.5019ZM10.85 14.7782L14.3285 12.5021C14.4979 12.3913 14.6 12.2025 14.6 12C14.6 11.7976 14.4979 11.6088 14.3285 11.498L10.85 9.22186V5.7482L20.4042 11.9998L10.85 18.2514L10.85 14.7782ZM3.35 18.2516L3.35 5.74845L12.9042 12L3.35 18.2516Z",
      fill: "currentColor"
    }
  )
);
const SvgSkip = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Skip_default = SvgSkip;
